import { useTranslation } from 'react-i18next';
import type { FormRule } from 'antd';
import { Button, Form, Input } from 'antd';
import { useCreateComment } from 'api/comments/use-create-comment.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import styles from './comment-form.module.scss';
import type { ICommentFormFields, ICommentFormProps } from './types';

const validationRule: Record<keyof ICommentFormFields, FormRule[]> = {
  text: [{ required: true, type: 'string', min: 3 }],
};

export const CommentFormComponent = (props: ICommentFormProps) => {
  const { entityId, entityName } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { mutateAsync: addComment, isLoading } = useCreateComment();

  const handleFinish = async (value: ICommentFormFields) => {
    await addComment({ ...value, entityName, entityId });
    form.resetFields();
  };

  return (
    <Form form={form} name='comment' layout='vertical' validateTrigger='onSubmit' onFinish={handleFinish}>
      <Form.Item name='text' rules={validationRule.text}>
        <Input.TextArea rows={3} placeholder={t('comment:add_comment')} />
      </Form.Item>
      <Form.Item className={styles.btnBox}>
        <Button type='primary' htmlType='submit' disabled={isLoading}>
          {t('common:submit')}
        </Button>
      </Form.Item>
    </Form>
  );
};

export const CommentForm = withRoleGuard<ICommentFormProps>(CommentFormComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
  UserRole.transport_manager,
  UserRole.storekeeper,
  UserRole.accountant,
]);
